import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f84e434c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn-container" }
const _hoisted_2 = {
  key: 0,
  class: "advanced-settings"
}

import { ref } from 'vue'
import AdvancedSettingsBtn from '@/components/AdvancedSettingsBtn.vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props



const showAdvancedSettings = ref(false)
const { getters } = useStore()
/**
 * default show advanced settings to find issue in time
 */
if (getters.isDev) {
  showAdvancedSettings.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_collapse_transition = _resolveComponent("el-collapse-transition")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdvancedSettingsBtn, {
        modelValue: showAdvancedSettings.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showAdvancedSettings).value = $event)),
        title: props.title
      }, null, 8, ["modelValue", "title"])
    ]),
    _createVNode(_component_el_collapse_transition, null, {
      default: _withCtx(() => [
        (showAdvancedSettings.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "default")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 64))
}
}

})